import { useState } from 'react';
import { PredefinedDoc } from '../../../constants/required-docs.constants';
import { styles } from '../../../styles/required-docs.styles';

export function DocCard({ 
  doc, 
  isSelected, 
  onToggle 
}: { 
  doc: PredefinedDoc; 
  isSelected: boolean; 
  onToggle: () => void 
}) {
  const [hovered, setHovered] = useState(false);
  const IconComponent = doc.icon;

  const cardStyle: React.CSSProperties = {
    ...styles.card,
    ...(isSelected ? styles.cardSelected : {}),
    ...(hovered && !isSelected ? { borderColor: '#9ca3af', backgroundColor: '#f9fafb' } : {}),
  };

  return (
    <div
      role="button"
      tabIndex={0}
      style={cardStyle}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      title={doc.description}
    >
      {isSelected && <div style={styles.checkmark}>{'\u2713'}</div>}
      <div style={styles.cardIcon}>
        <IconComponent size={32} />
      </div>
      <div style={styles.cardTitle}>{doc.label}</div>
      <div style={styles.cardFormats}>{doc.formats}</div>
    </div>
  );
}
